import { LoginRepository } from "../login.repository";
import { Select2Config } from "approot/global/ui-components/select2.directive";
import { LoginSelect2ConfigService } from "../services/login.select2.config.service";
import { SchoolSearchInfo } from "../loginform.component";
import { NamedEntityDto } from "approot/global/models/common.model";
import { IFormController } from "angular";
import { DialogsService } from "approot/global/providers/uikit.dialogs";
import { LoginService } from "../services/login.service";


interface IEsiaInfo {
    birthCertif,
    birthDate: string,
    email: string,
    fio: string,
    firstName: string,
    id: string,
    kids: IEsiaInfo[] | null,
    lastName: string,
    middleName: string,
    mobilePhone: string,
    passport,
    permissionGranted: boolean,
    snils: string,
    trusted: boolean
}

interface IFuncType {
    id: number,
    name: string
}

class ReportController {
    public esiaInfo
    public orgSettings: Select2Config;
    public form: IFormController;
    public loginState
    public esiaPermissions: boolean;
    public esiaRole
    public idp: string
    public roleName: string
    public classList: NamedEntityDto[]
    public mobileEntry: boolean;
    
    public selectedKid
    public organization: NamedEntityDto;
    public selectedClass: NamedEntityDto
    public additionalComment: string
    public regionSettings: any;

    public ready: boolean
    public reportNumber: string
    public isReportSuccess: boolean = false
    public isReportFailled: boolean = false
    public isReportSended: boolean = false
    public isSendingReport: boolean = false
    public reportErrorMessage: string

    public isPossibleMistakeRole: boolean = false
    public isParentWithoutKids: boolean = false
    public funcTypes: IFuncType[] = []
    public funcType: IFuncType
    public funcTypeName: "school" | "preSchool"
    public isShowDisclamer: boolean = true
    public organizations
    public ageMore20: boolean

    /*@ngInject*/
    constructor(
        private loginRepository: LoginRepository,
        private select2ConfigService: LoginSelect2ConfigService,
        public language: any,
        private $location: ng.ILocationService,
        public $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $dialogs: DialogsService,
        private loginService: LoginService,
    ) {
        const searchParams = new URLSearchParams(window.location.search)
        this.loginState = searchParams.get('loginState');
        this.esiaPermissions = searchParams.has('esia_permissions');
        this.esiaRole = searchParams.get('esiaRole');
        this.idp = searchParams.get('idp');

        if (this.esiaRole === '1') {
            this.roleName = 'Ученик'
        }
        if (this.esiaRole === '2') {
            this.roleName = 'Родитель'
        }
        if (this.esiaRole === '3') {
            this.roleName = 'Сотрудник'
        }

        this.init()
    }

    async init() {
        const funcTypes = await this.getFuncTypes()
        const esiaInfo = this.getEsiaInfo()
        const mobileInfo = this.getMobileInfo()
        const orgSettings = this.initOrgSettings();

        await Promise.all([funcTypes, mobileInfo, esiaInfo, orgSettings]);

        const users = this.loginService.accountInfo?.users
        if (!!users?.length) {
            const orgArray = users.map(user => {
                return this.getOrgInfo(user.displayName)
            })
            this.organizations = orgArray?.length > 1 ? orgArray.join(', ') : orgArray.join('')
        }
    }

    getOrgInfo (string): string {
        const openBracketIdx = string.indexOf('(') || null
        const closeBracketIdx = string.lastIndexOf(')') || null
        return string.substring(openBracketIdx+1, closeBracketIdx)
    }

    getFuncTypes() {
        this.loginRepository.getFuncTypes()
            .then((funcTypes: IFuncType[]) => {
                const preSchoolType = funcTypes.find((funcType: IFuncType) => funcType.id === 1)
                const schoolType = funcTypes.find((funcType: IFuncType) => funcType.id === 2)
                if (schoolType) {
                    this.funcTypes = [...this.funcTypes, schoolType]
                }
                if (preSchoolType && this.esiaRole !== "1") {
                    this.funcTypes = [...this.funcTypes, preSchoolType]
                }
            })
            .catch((err) => {
                this.$dialogs.error('Ошибка получения типов образовательных организаций.')
                    // .then(() => this.$window.location.href = "/")
            })
    }

    getMobileInfo() {
        this.loginService.getMobileInfo(this.loginState)
            .then((info) => {
                this.mobileEntry = info?.isMobile;
            })
    }

    isAgeMore20(birthDate: string): boolean {
        const birthDateObj = new Date(birthDate);
        const today = new Date();

        let years = today.getFullYear() - birthDateObj.getFullYear();

        return years >= 20
    }

    getEsiaInfo() {
        this.loginRepository.getEsiaProviderInfo(this.idp, this.loginState, this.esiaPermissions)
        .then((esiaInfo: IEsiaInfo) => {
            this.esiaInfo = esiaInfo

            this.ageMore20 = this.isAgeMore20(esiaInfo.birthDate)

            let userHaveKids
            if(!!esiaInfo.kids?.length) {
                this.selectedKid = esiaInfo.kids[0]
                userHaveKids = true
            } else {
                userHaveKids = false
            }
            
            this.ready = true

            const userIsAdult = new Date().getFullYear() - new Date(esiaInfo.birthDate).getFullYear() >= 18

            this.isPossibleMistakeRole = this.esiaRole === '1' && (userIsAdult || userHaveKids)
            this.isParentWithoutKids = this.esiaRole === '2' && !userHaveKids
        })
        .catch((err) => {
            console.log('err auth', err)
            this.$dialogs.error('Авторизационные данные истекли. Выполните авторизацию повторно.')
                .then(() => this.$window.location.href = "/")
        })
    }

    private initOrgSettings() {
        this.orgSettings = this.select2ConfigService.configure(<any>{
            placeholder: this.language.Generic.Login.kSelectOrganization,
            templateResult: (item, container) => {
                return this.select2ConfigService.displayOrgResult(item, container);
            },
            language: {
                inputTooShort: () => {
                    return this.language.Generic.Login.kEnterOrganizationNumberOrName;
                }
            },
            ajax: {
                // preSchool
                // School
                url: `/webapi/schools/search?withAddress=true&funcType=${this.funcTypeName}`,
                processResults: (data: SchoolSearchInfo[], query) => {
                    let showMsgAboutLongListOrgsFound = query.term?.length < 10 && data?.length > 20;
                    if (showMsgAboutLongListOrgsFound) {
                        return this.processResults([{ id: -2, name: this.language.Generic.Login.kLongSearchOrganizationResult }]);
                    }
                    return this.processResults(data);
                },
                getInitOptionsFn: () => {
                    return this.getAjaxInitOptionsFn(this.organization);
                }
            }
        });
    }

    private processResults(data) {
        let mappedData = data.map(i => {
            let optionItem = { id: i.id, text: null, obj: i };

            if (i.hasOwnProperty("shortName")) {
                optionItem.text = i.shortName;
            } else {
                optionItem.text = i.name;
            }

            return optionItem;
        });

        return { results: mappedData };
    }

    private getAjaxInitOptionsFn(data) {
		let options = null;

		if (data) {
			let opt = { id: data.id, text: data.name || data.text, obj: data };
			options = [opt];
		}

		return options ?? [];
	}

    getClassList (orgId) {
        this.loginRepository.getClasses(this.loginState, orgId)
            .then((classList) => {
                this.classList = classList
                if (this.classList && !!this.classList.length) {
                }
            })
            .catch((err) => {
                console.log('err classes', err)
                this.$dialogs.error('Авторизационные данные истекли. Выполните авторизацию повторно.')
                    .then(() => this.$window.location.href = "/")
            })
    }

    onSelectOrg() {
        if(this.organization && this.organization.id) {
            this.getClassList(this.organization.id)
        } else {
            this.classList = null
        }
    }

    onSelectFuncType() {
        if (this.funcType?.id === 1) {
            this.funcTypeName = "preSchool"
        } else if (this.funcType?.id === 2) {
            this.funcTypeName = "school"
        }
        this.orgSettings = null
        this.selectedClass = null
        this.organization = null
        this.classList = []

        setTimeout(() => {
            this.initOrgSettings()
            this.$scope.$applyAsync();
        }, 0)
    }

    onSubmit () {
        this.form.$displayErrors = true;

        if (!this.form.$valid) {
            return
        }

        if (!!this.isSendingReport) {
            return
        }

        this.isSendingReport = true

        let obj = {
            schoolId: this.organization.id,
            classId: this.selectedClass.id,
            kidOid: null,
            details: this.additionalComment,
            role: this.esiaRole
        }

        if (!!this.esiaInfo.kids?.length) {
            obj.kidOid = this.selectedKid?.id
        }

        this.loginRepository.sendReport(this.loginState, obj, this.idp)
            .then((response) => {
                this.isReportSuccess = true
                this.reportNumber = response.number

            })
            .catch((error) => {
                this.isReportFailled = true
                this.reportErrorMessage = error.data.message
            })
            .finally(() => {
                this.isReportSended = true
                this.isSendingReport = false
            })
    }

    cancel() {
        this.$window.history.back();
    }

    goBackMobile() {
        const accessRequestNumber = encodeURIComponent(this.reportNumber);
        const accessRequestDate = encodeURIComponent(new Date().toISOString());
    
        try {
            window.location.href = `irtech://mobile-app?accessRequestNumber=${accessRequestNumber}&accessRequestDate=${accessRequestDate}`;
        } catch (error) {
        }
    }


}

export const ReportComponent = {
    controller: ReportController,
    controllerAs: "$ctrl",
    templateUrl: "/static/dist/app/login/report/report.component.html",
}